(function (Drupal, $) {
  'use strict';

  Drupal.behaviors.vqfFaqs = {
    attach: function (context) {
      // Get the submit button element within the given context
      const submitButton = $(context).find('input[id^="edit-submit-faqs"]').get(0);

      if (submitButton) {
        $(submitButton).removeClass('uk-button-primary');
        $(submitButton).addClass('uk-button-secondary');
        // Add a click event listener to the submit button, ensuring it's only added once

      }
    }
  };
})(Drupal, jQuery);
